import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
import { PaintSplashes } from './components/PaintSplashes';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-accent-pink selection:text-white relative" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PaintSplashes data-id="element-2" />
      <div className="relative z-10" data-id="element-3">
        <CountdownBanner data-id="element-4" />
        <Hero data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <TomosSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <BenefitsSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <Footer data-id="element-15" />
      </div>
      <SocialProofToast data-id="element-16" />
    </div>;
}